import { useScriptClarity, useScriptGoogleAnalytics, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleAnalytics = useScriptGoogleAnalytics({"id":"G-VP6MS1BENZ"})
    const clarity = useScriptClarity({"id":"qlis9utyan"})
    return { provide: { $scripts: { googleAnalytics, clarity } } }
  }
})